import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { BaseComponent } from '../../base/base.component';
import { ChangePasswordRequestVM } from '../../../models';
import { Utils } from '../../../utils/utils';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'SettingsComponent',
  templateUrl: './settings.component.html'
})
export class SettingsComponent extends BaseComponent implements OnInit {

  model: ChangePasswordRequestVM = new ChangePasswordRequestVM();
  myForm: FormGroup;

  constructor(private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {
    super(route);
  }

  ngOnInit(): void {
    this.myForm = this.fb.group({
      newPassword: new FormControl('', [Validators.required, Validators.pattern(this.globalSettings.passwordRules)]),
      confirmPassword: new FormControl('', Validators.required),
    }, { validator: Utils.checkIfMatchingPasswords('newPassword', 'confirmPassword') });
  }

  onSubmit(): void {
    this.markAsTouched(this.myForm);
    if (this.myForm.valid) {
      this.model.username = this.me.username;
      this.emitDisplayLoadingDialog(true);
      this.authService.changePassword(this.model)
        .subscribe(returnValue => {
          if (returnValue) {
            this.showDialog("Password changed successfully", false);
            this.model = new ChangePasswordRequestVM();
            this.myForm.reset();
          }
          else {
            this.showDialog("Changes not saved, please try again", true);
          }
        },
          error => {
            this.showDialog("Changes not saved, please try again", true);
          },
          () => { this.emitDisplayLoadingDialog(false); }
        )
    }
  }

  cancel() {
    this.router.navigateByUrl('/');
    return false;
  }

}
